import { render, staticRenderFns } from "./CloFooterBadges.vue?vue&type=template&id=6a945dee&"
import script from "./CloFooterBadges.vue?vue&type=script&lang=js&"
export * from "./CloFooterBadges.vue?vue&type=script&lang=js&"
import style0 from "./CloFooterBadges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports